import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import FeaturedImage from "../../../assets/images/ads/MarchMadness.jpg";
import { connect } from 'react-redux';
import * as UserActions from '../../../actions/userActions';

class SpecialOffers extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      productUrl: '',
    }
    this._onSubmit = this._onSubmit.bind(this);
  }
  _onSubmit(e) {
    e.preventDefault();
    let { email } = this.state;
    console.log(email);
    if (email) {
      this.props.dispatch(UserActions.subscribeNews({
        email
      }, response => {
        console.log("News_Letter_RESPONSE", response);
        if (response.status) {
          this.setState({
            email: ''
          }, () => setTimeout(() => alert("Success"), 400))
        } else {
          if (response.data.error.code == 11000) {
            alert("Email already subscribed");
          }
        }
      }))
    }
  }

  render() {
    const { promoImage } = this.props;
    const productData  = this.props.promoImage && this.props.promoImage.ProductId && this.props.promoImage.ProductId[0];
    
    return (
      promoImage && promoImage.PromoImage && promoImage.PromoImage[0] ? 
      <div className="special-offers">
        <div className="row">
            {productData ?
              <div className="col-md-12 col-lg-7 featured-image-container banner-container">
             <img src={promoImage.PromoImage[0]} className="image" alt='Promotional banner' />
             <div className="middle">
             <div className="list-group">
             <span className='promotional-item-text pb-2'>PROMOTIONAL PRODUCTS :</span>
             <ul>
             {
              this.props.promoImage.ProductId.map((productid, i) => {     
              let currentUrl = `products/${productid._id}`;                 
              return (<li key={i} className="promotional-item-text pl-2"><Link to={currentUrl} >{productid.Description}</Link></li>) 
              })
             }
             </ul>
             </div>
             </div>
             </div>
              :
              <div className="col-md-12 col-lg-7 featured-image-container"> <img src={promoImage.PromoImage[0]} alt='Promotional banner' /> </div>}
          <div className="col-md-12 col-lg-5 featured-content-container">
            <h2>SIGNUP TO RECEIVE JASON’S SPECIAL OFFERS AND NEWS!</h2>
            <p>HERE AT JASON’S WE ARE ALWAYS OFFERING NEW ITEMS AND SPECIALS IN STORE AND FOR DELIVERY, SIGN UP TO STAY UP TO DATE WITH WHAT WE HAVE AVAILABLE!</p>
            <div className="newsletter-input-container">
              <form onSubmit={this._onSubmit}>
                <input required type="email" aria-label="email" className="newsletter-input" onChange={(e) => this.setState({ email: e.target.value })} value={this.state.email} placeholder="ENTER YOUR EMAIL" />
                <button type="submit" className="register-button">Register!</button>
              </form>
            </div>
          </div>
        </div>
        </div>
        : null
    );
  }
}

export default connect((state) => {
    return {
        promoImage: state.getIn(['users', 'promoImage']),
    };
})(SpecialOffers);



// WEBPACK FOOTER //
// ./src/components/home/special-offers/SpecialOffers.js